import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileEntriesPageComponent } from './profile-entries-page.component';

/** ルーティング */
const routes: Routes = [
  {
    path: '',
    component: ProfileEntriesPageComponent,
  },
];

/**
 * エントリーページルーティングモジュール
 */
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProfileEntriesPageRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/page/profile-entries-page/profile-entries-page-routing.module.ts